export const blockIconsActivitiesExperimentNew = (
	<span className='material-symbols-outlined'>experiment</span>
);
